import { IRootState } from 'app/shared/reducers';
import { createSelector } from 'reselect';
import { GlobalState } from './state';

const selectGlobalState = (state: IRootState) => state.global;

export const getConfiguration = createSelector<IRootState, GlobalState, any>(
  selectGlobalState,
  (state: GlobalState) => state.configuration
);

export const getAvatarByCode = (code: number) =>
  createSelector<IRootState, GlobalState, any>(selectGlobalState, (state: GlobalState) => state.lstAvatars.find(a => a?.code === code));
